import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconAddSocialOrder: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.CERULEAN,
    }}
    {...props}
  >
    <path 
        d="M13.89 6.9C14.43 7.09 14.93 7.48 15.22 8.01C15.52 8.49 15.62 9.07 15.52 9.6C15.47 9.89 15.67 10.13 15.96 10.18H16.06C16.31 10.18 16.55 9.99 16.6 9.75C16.7 8.98 16.55 8.21 16.15 7.54C15.71 6.82 15.06 6.29 14.27 6C13.97 5.9 13.68 6.05 13.58 6.29C13.43 6.53 13.58 6.82 13.88 6.92L13.89 6.9Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M14.18 4.64C15.47 4.98 16.55 5.79 17.25 6.9C17.84 7.96 18.04 9.21 17.79 10.36C17.74 10.65 17.89 10.89 18.19 10.99H18.29C18.54 10.99 18.74 10.85 18.78 10.6C19.08 9.16 18.88 7.66 18.09 6.41C17.3 5.01 15.96 4.05 14.38 3.67C14.08 3.62 13.84 3.77 13.74 4.06C13.74 4.3 13.89 4.54 14.18 4.64Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M8.93999 15.18L15.07 14.17C15.71 14.07 16.06 13.35 15.71 12.82L11.41 5.55C11.21 5.26 10.92 5.07 10.62 5.07C10.37 5.07 10.08 5.17 9.87999 5.41L5.42999 10.7C5.37999 10.8 5.27999 10.84 5.17999 10.89L2.45999 12.43C2.01999 12.67 1.86999 13.25 2.10999 13.68L3.88999 16.62C4.08999 16.91 4.37999 17.05 4.67999 17.05C4.82999 17.05 4.97999 17 5.11999 16.91L7.43999 15.61L8.81999 17.97C8.96999 18.21 9.21999 18.36 9.50999 18.36C9.65999 18.36 9.75999 18.31 9.90999 18.26C10.26 18.07 10.4 17.59 10.21 17.25L8.91999 15.18H8.93999ZM7.89999 13.78C7.59999 13.83 7.30999 13.92 7.05999 14.07L4.92999 15.27L3.83999 13.44L6.01999 12.24C6.26999 12.1 6.50999 11.9 6.70999 11.66L10.52 7.14L13.83 12.82L7.89999 13.78Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M18.63 13.91C16.36 13.91 14.48 15.74 14.48 17.95C14.48 20.16 16.36 21.99 18.63 21.99C20.9 21.99 22.78 20.16 22.78 17.95C22.78 15.74 20.9 13.91 18.63 13.91ZM18.63 20.84C17 20.84 15.66 19.54 15.66 17.95C15.66 16.36 17 15.06 18.63 15.06C20.26 15.06 21.6 16.36 21.6 17.95C21.6 19.54 20.26 20.84 18.63 20.84Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M20.06 17.48H19.12V16.57C19.12 16.33 18.92 16.09 18.63 16.09C18.34 16.09 18.14 16.28 18.14 16.57V17.48H17.2C16.95 17.48 16.71 17.67 16.71 17.96C16.71 18.25 16.91 18.44 17.2 18.44H18.14V19.35C18.14 19.59 18.34 19.83 18.63 19.83C18.92 19.83 19.12 19.64 19.12 19.35V18.44H20.06C20.31 18.44 20.55 18.25 20.55 17.96C20.55 17.67 20.3 17.48 20.06 17.48Z" 
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
